



























import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import "moment-timezone";
import moment from "moment";
import { formatDateTimeStringWithZone } from "@/shared/dateString";

@Component
export default class DrivewealthW9 extends Vue {
  moment = moment;
  formatDateTimeStringWithZone = formatDateTimeStringWithZone;

}
